/** 極簡事件匯流排：系統之間只透過事件溝通，UI 不直接改遊戲狀態。 */
export type GameEventMap = {
  toast: string;
  stateChanged: void;
  floorChanged: string;
  caseStageChanged: { caseId: string; stage: string };
  violation: { caught: boolean; door: string };
  injury: { label: string; severity: string };
  dayEnded: void;
  sfx: 'click' | 'ok' | 'warn' | 'alarm' | 'rewind' | 'door' | 'item';
};
type Handler<T> = (payload: T) => void;
class Bus {
  private map = new Map<keyof GameEventMap, Set<Handler<any>>>();
  on<K extends keyof GameEventMap>(k: K, fn: Handler<GameEventMap[K]>): () => void {
    if (!this.map.has(k)) this.map.set(k, new Set());
    this.map.get(k)!.add(fn);
    return () => this.map.get(k)!.delete(fn);
  }
  emit<K extends keyof GameEventMap>(k: K, payload: GameEventMap[K]): void {
    this.map.get(k)?.forEach(fn => fn(payload));
  }
}
export const bus = new Bus();
